(function() {
    window.addEventListener('AdsGun::ready', () => {
        const STYLE_ID = 'adsgun-header-height-fix';

        function updateHeaderHeight() {
            const header = document.querySelector('[id^="shopify-section-header"]');
            if (!header) return;
            
            const headerHeight = header.offsetHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            let style = document.getElementById(STYLE_ID);

            if (scrollTop < headerHeight) {
            // Add/update style element
            if (!style) {
                style = document.createElement('style');
                style.id = STYLE_ID;
                document.head.appendChild(style);
            }
            style.textContent = `:root { --header-height: ${headerHeight}px !important; }`;
            } else {
            // Remove style element
            if (style) {
                style.remove();
            }
            }
        }

        // Run on scroll
        window.addEventListener('scroll', updateHeaderHeight, { passive: true });

        // Run on load
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateHeaderHeight);
        } else {
            updateHeaderHeight();
        }

        // Run after a short delay to catch any changes
        setTimeout(updateHeaderHeight, 100);
        setTimeout(updateHeaderHeight, 500);

        window.addEventListener('click', function(event) {
            // Check if clicked element OR its parent has aria-controls="header-sidebar-menu"
            let target = event.target;

            // Check the clicked element itself
            if (target.getAttribute('aria-controls') === 'header-sidebar-menu') {
            console.log('[NavDrawer Fix] Menu button clicked directly:', target);
            }
            // Or check if it's inside an element with aria-controls
            else {
            target = target.closest('[aria-controls="header-sidebar-menu"]');
            }

            if (target) {
            console.log('[NavDrawer Fix] Menu button clicked:', target);

            // Small delay to let the drawer be added first
            setTimeout(function() {
                const drawers = document.querySelectorAll('navigation-drawer');

                console.log('[NavDrawer Fix] Found', drawers.length, 'drawer(s)');

                if (drawers.length > 1) {
                // Remove all except the first one
                for (let i = 1; i < drawers.length; i++) {
                    console.log('[NavDrawer Fix] Removing duplicate drawer', i);
                    drawers[i].remove();
                }
                console.log('[NavDrawer Fix] Kept 1 drawer, removed', drawers.length - 1, 'duplicate(s)');
                }
            }, 50); // 50ms delay
            }
        });
    });
})();

